import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const RenderModal = ({ id, title, toggleModal, activeModal, footer, children }) => {
  return (
    <Modal
      isOpen={activeModal === id}
      toggle={() => toggleModal(id)}
      key={id}
      className="modal-dialog-centered modal-lg"
      fade={false}
    >
      {title && <ModalHeader toggle={() => toggleModal(null)}>{title}</ModalHeader>}
      <ModalBody className="px-sm-3 mx-50 p-3">{children}</ModalBody>
      {footer && <ModalFooter>{footer}</ModalFooter>}
    </Modal>
  )
}

export default RenderModal
